import "../../../../resources/less/Admin/Signup/signup.less";

export default class VSignup {
  private readonly _acceptButton: JQuery<HTMLButtonElement>;
  private readonly _form: JQuery<HTMLFormElement>;
  private readonly _submit: JQuery<HTMLButtonElement>;

  constructor() {
    this._submit = $(".create_manager_form_submit");

    this._acceptButton = $(".admin-popup-accept");
    this._form = $('form[name="signup_form"]');
  }

  public get acceptButton(): JQuery<HTMLButtonElement> {
    return this._acceptButton;
  }

  public get submit(): JQuery<HTMLButtonElement> {
    return this._submit;
  }

  public get form(): JQuery<HTMLFormElement> {
    return this._form;
  }

  public SubmitEnabled(value: boolean) {
    if (value) {
      this.submit.removeClass("invalid");
    } else {
      this.submit.addClass("invalid");
    }
  }
}
